import React from 'react';

const LoadingScreen = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-[#202020] select-none transition-opacity duration-500">
      <div className="relative flex flex-col items-center justify-center">
        {/* Pulsing Seismic Rings */}
        <div className="absolute w-44 h-44 rounded-full border border-rose-500/30 animate-ping" style={{ animationDuration: '2.5s' }} />
        <div className="absolute w-64 h-64 rounded-full border border-rose-500/15 animate-ping" style={{ animationDuration: '3.5s', animationDelay: '0.6s' }} />
        
        {/* Logo Card */}
        <div className="relative z-10 px-8 py-6 bg-[#282828] rounded-2xl border border-neutral-800 shadow-2xl flex flex-col items-center">
          <img src="/Logo.png" alt="Quakify Logo" className="w-[170px] h-[55px] object-contain drop-shadow" />
          
          <div className="mt-5 flex items-center gap-2.5">
            <span className="w-2.5 h-2.5 rounded-full bg-rose-500 animate-pulse" />
            <p className="inter text-sm text-[#D2D2D2] tracking-wide font-normal">
              Küresel Deprem Verileri Yükleniyor...
            </p>
          </div>
          
          {/* Progress Indicator */}
          <div className="w-48 h-1 bg-[#1a1a1a] rounded-full mt-4 overflow-hidden">
            <div 
              className="w-1/2 h-full bg-gradient-to-r from-rose-500 to-amber-500 rounded-full"
              style={{
                animation: 'quakeProgress 1.4s ease-in-out infinite'
              }}
            />
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes quakeProgress {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(50%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
